import UCRImg from "../assets/ucr-image.png";
import GTUImg from "../assets/gtu-image.png";
import ProfileImg from "../assets/profile-image.jpg";
import UCImg from "../assets/uc-image.webp";
import MarlabsImg from "../assets/marlabs-image.png";
import BlackStoneImg from "../assets/blackstone-image.png";
const AboutHistoryData = [
  {
    imgsrc: ProfileImg,
    title: "Who am I?",
    description:
      "I'm a Full-stack developer. I build systems that are scalable and user-friendly."
  },
  {
    imgsrc: UCImg,
    title: "Master's Degree",
    description:
      "Pursuing Master's degree in Business Administration from University of the Cumberlands."
  },
  {
    imgsrc: MarlabsImg,
    title: "Software Developer at Marlabs",
    description:
      "Revamped the websites using Angular, increasing user engagement by 35% and improving performance with automation and modular design."
  },
  {
    imgsrc: BlackStoneImg,
    title: "Software Developer at BlackStone Technologies LLC",
    description:
      "Enhanced UI and optimized form structures using Angular, improving user engagement and data accuracy, while implementing unit tests for critical components."
  },
  {
    imgsrc: UCRImg,
    title: "Master's Degree",
    description:
      "I completed my Master's degree in Computer Science from University of California, Riverside."
  },
  {
    imgsrc: GTUImg,
    title: "Bachlor's Degree",
    description:
      "I completed my Bachlor's degree in Computer Engineering from Gujarat Technological University, Ahmedabad."
  }
];

export default AboutHistoryData;
